export default {
  form: {
    owner_phone_number: {
      label: 'Kontaktpersonens telefonnummer',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Kontaktpersonens e-mail',
      placeholder: 'Indtast e-mail',
    },
    owner_first_name: {
      label: 'Fornavn',
      placeholder: 'Indtast fornavn',
    },
    owner_last_name: {
      label: 'Efternavn',
      placeholder: 'Indtast efternavn',
    },
    owner_dob: {
      label: 'Fødselsdato',
      placeholder: 'Dato',
    },
    owner_id_number: {
      label: 'ID-nummer (f.eks. cpr-nummer eller Social Security Number i USA)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Tilbage',
    next: 'Næste',
  },
};
